function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyMilestones({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 82,
    viewBox: "0 0 420 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.536133,
    y: 0.5,
    width: 418,
    height: 81,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.536133,
    y: 0.5,
    width: 418,
    height: 81,
    stroke: "#D5D6D8",
    style: {
      stroke: "#D5D6D8",
      stroke: "color(display-p3 0.8353 0.8392 0.8471)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0361,
    y: 16,
    width: 144,
    height: 24,
    rx: 12,
    fill: "#808389",
    style: {
      fill: "#808389",
      fill: "color(display-p3 0.5020 0.5137 0.5373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0361,
    y: 50,
    width: 104,
    height: 16,
    rx: 8,
    fill: "#ABACB1",
    style: {
      fill: "#ABACB1",
      fill: "color(display-p3 0.6706 0.6745 0.6941)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.036,
    y: 33,
    width: 88,
    height: 16,
    rx: 8,
    fill: "#D5D6D8",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMilestones);
export default __webpack_public_path__ + "static/media/empty-milestones.a7f32703dcad63cf8fa56efdb018c54c.svg";
export { ForwardRef as ReactComponent };